export const setListaTrabajos = (state, listaTrabajos) => {
  state.listaTrabajos = listaTrabajos;
};

export const setPerfil = (state, dataPerfil) => {
  state.perfil = dataPerfil;
};

export const setDraftsPropuestaDialog = (state, payload) => {
  state.draftsPropuestaDialog = payload;
};
